import { useSelector as useSelectorShared } from "react-redux"

export const useSelector = useSelectorShared
